import type { Address } from '@baseball-near-you/prisma';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useTeamAddressCreationMutation() {
  const queryClient = useQueryClient();
  const {
    mutate: createTeamAddress,
    isLoading: isCreatingAddress,
    error: addressCreationError,
  } = useMutation({
    mutationFn: async (data: Partial<Address> & { teamId: number }) => {
      const newAddress = await clients.address.createTeamAddress({
        payload: data,
      });

      return newAddress;
    },
    onSuccess: () => queryClient.refetchQueries([QueryKey.Team]),
  });

  return {
    createTeamAddress,
    isCreatingAddress,
    addressCreationError,
  };
}
